import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { OktaAuthService } from '@okta/okta-angular';
import { PraService } from "../services/pra.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Ng2DeviceService } from 'ng2-device-detector';

@Component({
  selector: 'login',
  templateUrl: './app.logincomponent.html',
  styleUrls: ['./app.logincomponent.css']
})

export class LoginComponent {
  loginFormAd: FormGroup;
  submittedAd = false;
  returnUrl: string;
  error = '';
  title = 'login';
  impersonation: boolean = false;

  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  currentUser: string;

  //Okta variables
  isAuthenticated: boolean;
  oktaUserName: string;
  accessToken: string;

  //Browser detector
  deviceInfo = null;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public oktaAuth: OktaAuthService,
    private PraService: PraService,
    private http: HttpClient,
    private deviceDetectorService: Ng2DeviceService,
    private authenticationService: AuthenticationService) {
    // the browser detector
    this.browserDetector();

    this.impersonation = environment.impersonation
  }

  async ngOnInit() { }

  // device detector to check the browser and device
  browserDetector(): void {
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
    console.log(this.deviceInfo.browser);

    if (this.deviceInfo.browser !== 'ie') {
      this.checkAuth();
    }
  }


  async checkAuth() {
    //For impersonation login
    this.loginFormAd = this.formBuilder.group({
      usernameAd: ['', Validators.required]
    });

    //Okta auth check
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (this.isAuthenticated) {
      const userClaims = await this.oktaAuth.getUser();

      if (!environment.impersonation) {
        this.currentUser = userClaims.email;
        this.getUserInfo(this.currentUser);
      }
      console.log(userClaims);
      this.accessToken = await this.oktaAuth.getAccessToken();
      console.log(this.accessToken);

    } else {
      //Login to Okta
      this.oktaLogin();
    }

    // subscribe to authentication state changes
    this.oktaAuth.$authenticationState.subscribe(
      (isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated
    );
  }


  // convenience getter for easy access to form fields
  get g() { return this.loginFormAd.controls; }


  onSubmitAd() {
    this.submittedAd = true;

    // stop here if form is invalid
    if (this.loginFormAd.invalid) {
      return;
    }
    this.currentUser = this.g.usernameAd.value;
    this.getUserInfo(this.currentUser);

  }

  getUserInfo(user) {
    //Get user info to verify user
    this.loading = true;
    this.authenticationService.loginAD(user, '1')
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          if (data.isSuccess) {
            this.router.navigate(['/']);
          } else {
            if (data.errMsg) {
              this.error = data.errMsg;

            }
          }

        },
        error => {
          if (error.status === 500) {
            this.error = 'The user does not exist in our system.';
          }
          this.loading = false;

        });
  }

  async oktaLogin() {
    try {
      await this.oktaAuth.loginRedirect();
    } catch (err) {
      console.error(err);
      this.error = err;
    }
  }


  logout() {
    this.oktaAuth.logout('/');
  }

}

